var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.765.833H2.236A1.33 1.33 0 0 0 .89 2.144v15.712a1.33 1.33 0 0 0 1.347 1.31h15.529a1.33 1.33 0 0 0 1.347-1.31V2.144a1.33 1.33 0 0 0-1.347-1.31M6.416 16.178h-2.75v-8.25h2.75zM5.041 6.773a1.43 1.43 0 0 1 0-2.86 1.44 1.44 0 1 1 0 2.86m11.293 9.405h-2.75v-4.427c0-1.11-.394-1.834-1.393-1.834a1.51 1.51 0 0 0-1.412 1 1.8 1.8 0 0 0-.091.669v4.583h-2.75V7.92h2.75v1.164a2.75 2.75 0 0 1 2.484-1.375c1.833 0 3.162 1.183 3.162 3.722z"
  })));
};
export default SvgLinkedin;